import React from 'react';

// Heart bubble decoration (red bubble with white heart)
const HeartBubble = ({ size = 80, className = '', rotate = 0 }) => {
  return (
    <div
      className={`heart-bubble ${className}`}
      style={{
        width: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 100 110"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id={`hb-${size}-${rotate}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#ff4d6a" />
            <stop offset="100%" stopColor="#d6354f" />
          </linearGradient>
        </defs>
        {/* Speech bubble shape */}
        <path
          d="M14 6 H86 Q96 6 96 18 V70 Q96 82 86 82 H46 L30 102 L34 82 H14 Q4 82 4 70 V18 Q4 6 14 6 Z"
          fill={`url(#hb-${size}-${rotate})`}
        />
        {/* Heart */}
        <path
          d="M50 60 C42 53 28 48 28 36 C28 28 34 22 42 22 C46 22 49 24 50 27 C51 24 54 22 58 22 C66 22 72 28 72 36 C72 48 58 53 50 60 Z"
          fill="#ffffff"
        />
        {/* Highlight */}
        <ellipse cx="30" cy="22" rx="6" ry="3" fill="#ffffff" opacity="0.45" />
      </svg>
    </div>
  );
};

export default HeartBubble;
